<!--
  ReApprovalRollup.vue -- Phase 4.6 per-client re-approval breakdown.

  Card: 2026-06-13 design bundle implementation -- https://trello.com/c/hYlwyKYT
  Pebble: Phase 4.6 BulkApplySetModal (full UI).

  P4-Q4: when bulk-apply causes a >10% resize on at least one decoration,
  the affected artwork needs re-approval. Surface the count split by
  client so the Distributor knows which storefronts will see a pending
  workspace bump.

  Renders nothing when totalCount === 0; otherwise renders a notice line
  with the total + a comma-separated per-client breakdown.
-->
<template>
    <div
        v-if="totalCount > 0"
        class="re-approval-rollup"
        data-testid="re-approval-rollup"
    >
        <strong class="re-approval-rollup__total">
            {{ totalCount }} re-approval{{ totalCount === 1 ? '' : 's' }}
            needed
        </strong>
        <span v-if="perClient.length" class="re-approval-rollup__by-client">
            ({{ perClientPhrase }})
        </span>
    </div>
</template>

<script>
export default {
    name: 'ReApprovalRollup',
    props: {
        totalCount: {
            type: Number,
            required: true,
            default: 0,
        },
        perClient: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        perClientPhrase() {
            return this.perClient
                .map((c) => `${c.count} from ${c.client_name}`)
                .join(', ')
        },
    },
}
</script>

<style scoped>
.re-approval-rollup {
    padding: 8px 12px;
    background: #fef3c7;
    border-left: 3px solid #f59e0b;
    border-radius: 4px;
    font-size: 13px;
    color: #78350f;
}
.re-approval-rollup__total {
    margin-right: 4px;
}
.re-approval-rollup__by-client {
    color: #92400e;
}
</style>
